import { AxiosResponse } from "axios";
import { api } from "../api";
import { ContentHealthSummaryResponse } from "./content-health.types";

export const getHealthSummary = async (
  refresh?: boolean
): Promise<ContentHealthSummaryResponse> => {
  try {
    const response: AxiosResponse<ContentHealthSummaryResponse> =
      await api.get(
        "/admin/content/health-summary",
        refresh ? { params: { refresh: true } } : undefined
      );
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};
